interface CertificationProps {
  subject: string;
  certificates: string;
  name1: string;
  name2: string;
  name3: string;
  count: number;
  rate: number;
}

const Certification: React.FC<CertificationProps> = ({
  subject,
  certificates,
  name1,
  name2,
  name3,
  count,
  rate,
}) => {
  return (
    <div>
      {certificates == "true" ? (
        <div className="m-3 px-3 pt-3 pb-1 bg-slate-100 dark:bg-slate-500 rounded-lg text-slate-700 dark:text-slate-200">
          <div className="text-xl font-bold">🏆학습 완료🏆</div>
          <div className="font-bold text-5xl mt-3">{name2}</div>
          <div className="text-sm my-3">{name3}</div>
          <div className="flex justify-between">
            <span className="font-bold">스톰스터디 인증</span>
            <span>학습단어 {count} 개</span>
            <span>
              <img
                src="image_transparent.png"
                className="h-7 w-7 rounded-full"
              />
            </span>
          </div>
        </div>
      ) : (
        ""
      )}
    </div>
  );
};

export default Certification;
